import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { StringUtils } from "Global/Base/Utils/StringUtils";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";

const logger = LazyLoadingSectionLogger.create(LoggingSection.localizations);

/**
 * Vytvoří textový element obsahující lokalizovaný text
 * @includeToDoc
 */
export class LocalizedStringBuilder implements IContentBuilder {
    private _locKey: string = "";
    private _params: string[] = [];

    constructor(locKey: string, params?: string[]) {
        this._locKey = locKey;
        if (params && params.length > 0)
            this._params = params;
    }

    public async build(): Promise<HTMLElement> {
        let text = await this.getPlainString();
        text = StringUtils.stringToHTMLText(text);

        if (this._params.length > 0)
            text = StringUtils.format(text, this._params);

        return createElement({
            html: text,
        });
    }

    public async getPlainString(): Promise<string> {
        try {
            return await Localization.getTextPromise(this._locKey);
        } catch (e) {
            logger.error(e);
            return "???";
        }
    }
}
